import {
  type ApiTableCommandFactory,
  advancedFilterInitialState,
} from 'components/ApiTable/model/ApiTableModel';
import { reloadTableData } from 'components/ApiTable/model/commands/reloadTableData';
import { selectFilterPreset } from 'components/ApiTable/model/commands/selectFilterPreset';
import { setFilters } from 'components/ApiTable/model/commands/setFilters';

export const closeAdvancedFilter: ApiTableCommandFactory =
  (cmdContext, dispatch) => () => {
    cmdContext.updateState((draft) => {
      draft.advancedFilter = advancedFilterInitialState;
    });

    // if last submit was from advanced filter, reset:
    // if there is active preset, then to active preset, otherwise to empty
    if (
      cmdContext.getState().filtersOrigin === 'advanced' &&
      Object.keys(cmdContext.getState().filters).length > 0
    ) {
      const preset = cmdContext.getState().selectedFilterPreset;
      if (preset) {
        dispatch(selectFilterPreset, { preset });
      } else {
        dispatch(setFilters, { filters: {}, origin: 'empty' });
        dispatch(reloadTableData);
      }
    }
  };
